import * as React from "react";
import NavBar from "./navBar";
import FilterSection from "./filterSection";
import MainSection from "./mainSection";
import Footer from "./footer";
import "../css/common.css";
import { getSeoMainPage } from "../utils/seoUtils";
import BannerNotification from "./bannerNotification";
import connect from "react-redux/lib/connect/connect";

const mapStateToProps = (state) => {
    return {
        marketFilter: state.filters.market,
    };
};

class Home extends React.Component {
    render() {
        return (
            <div className="main">
                {getSeoMainPage(this.props.marketFilter || "gta")}
                <BannerNotification />
                <NavBar />
                <FilterSection />
                <MainSection />
                <Footer />
            </div>
        );
    }
}

export default connect(mapStateToProps)(Home);
